;(function () {
  const SECTION_SELECTOR = '[data-instagram-app]'
  const INIT_ATTR = 'data-instagram-app-initialized'

  function formatCount(total, suffix) {
    if (!total) return ''
    return suffix ? `${total} ${suffix}` : String(total)
  }

  function updateCount(section) {
    const countEl = section.querySelector('[data-instagram-app-count]')
    if (!countEl) return

    const slider = section.querySelector('.fs-slider-container')
    if (!slider) {
      countEl.textContent = ''
      return
    }

    const items = slider.querySelectorAll('.fs-entry-container')
    const total = items.length
    const suffix = section.dataset.countSuffix || ''

    countEl.textContent = formatCount(total, suffix)
  }

  function bindControls(section) {
    const controls = section.querySelector('[data-instagram-app-controls]')
    const prev = section.querySelector('[data-instagram-app-prev]')
    const next = section.querySelector('[data-instagram-app-next]')

    if (!prev || !next) {
      return
    }

    let attempts = 0

    function tryAttach() {
      const sliderPrev = section.querySelector('.fs-slider-prev-button')
      const sliderNext = section.querySelector('.fs-slider-next-button')
      const slider = section.querySelector('.fs-slider-container')

      if (!sliderPrev || !sliderNext || !slider) {
        attempts += 1
        if (attempts < 30) {
          window.setTimeout(tryAttach, 200)
        }
        return
      }

      prev.addEventListener('click', () => sliderPrev.click())
      next.addEventListener('click', () => sliderNext.click())

      if (controls) {
        controls.hidden = false
      }

      updateCount(section)

      const observer = new MutationObserver(() => updateCount(section))
      observer.observe(slider, { childList: true, subtree: true })
      section.__instagramAppObserver = observer
    }

    tryAttach()
  }

  function initSection(section) {
    if (section.hasAttribute(INIT_ATTR)) {
      return
    }

    section.setAttribute(INIT_ATTR, 'true')
    bindControls(section)
    updateCount(section)
  }

  function cleanupSection(section) {
    if (section.__instagramAppObserver) {
      section.__instagramAppObserver.disconnect()
      delete section.__instagramAppObserver
    }
    section.removeAttribute(INIT_ATTR)
  }

  function initAll(root) {
    const sections = (root || document).querySelectorAll(SECTION_SELECTOR)
    sections.forEach(initSection)
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document))

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target)
  })

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(SECTION_SELECTOR).forEach((section) => cleanupSection(section))
  })
})()
